import { Navigate } from "@tanstack/react-router";
import { useState } from "react";
import { ReactComponent as WelcomeIcon } from "assets/img/discussions/welcome.svg";
import { Button } from "components/elements";

type NoDiscussionsProps = {
    setModalOpen: (open: boolean) => void;
};

export const NoDiscussions = ({ setModalOpen }: NoDiscussionsProps) => {
    return (
        <>
            <div className="flex flex-1 flex-col items-center justify-center rounded-2xl border border-[#c8c8c8] bg-white p-6 text-center">
                <div className="mb-4">
                    <WelcomeIcon className="h-20 w-20" />
                </div>
                <h2 className="mb-2 text-lg font-semibold">Welcome to your discussions</h2>
                <p className="mb-4 text-sm text-gray-500">
                    You can receive and exchange information of interest.
                </p>
                <Button onClick={() => setModalOpen(true)} variant="primary">
                    Start a discussion
                </Button>
            </div>
        </>
    );
};
